import { Routes, Route, Navigate } from 'react-router-dom';

import { ConfigurationsPage, ConfigurationDetailsPage } from './components/ConfigurationsPage';
import PermissionsPage from './components/PermissionsPage';

export default function SettingsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="configurations" replace />} />
      <Route path="configurations" element={<ConfigurationsPage />}>
        <Route index element={<ConfigurationDetailsPage />} />
        <Route path=":nodeId" element={<ConfigurationDetailsPage />} />
      </Route>
      <Route path="permissions" element={<PermissionsPage />} />
    </Routes>
  );
}
